module.exports = __webpack_public_path__ + "static/img/banner3View.55283bd3.jpg";